var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9546 19.498L11.9654 19.4876M11.9654 19.4876L19.5888 12.158M11.9654 19.4876C12.0052 19.4461 12.0482 19.4046 12.0948 19.3632M11.9654 19.4876C10.928 20.5714 12.1432 21.68 13.2606 20.6356M13.2384 20.6575L13.2606 20.6356M13.2606 20.6356L20.74 13.2535M19.5708 12.1781C20.3911 11.383 21.6778 12.3085 20.7124 13.2847",
    stroke: "#ffffff",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6736 19.498L20.6628 19.4876M20.6628 19.4876L13.0393 12.158M20.6628 19.4876C20.623 19.4461 20.5799 19.4046 20.5334 19.3632M20.6628 19.4876C21.7001 20.5714 20.4849 21.68 19.3676 20.6356M19.3898 20.6575L19.3676 20.6356M19.3676 20.6356L11.8882 13.2535M13.0573 12.1781C12.237 11.383 10.9504 12.3085 11.9158 13.2847",
    stroke: "#ffffff",
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.4e301561567406425fb7383d29890a80.svg";
export { ForwardRef as ReactComponent };